<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <!-- <div slot="header" class="clearfix"><b>订单列表</b></div> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.ccorpcode" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname" :value="item.ccorpcode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单日期">
          <!-- <el-date-picker v-model="formInline.ddeliverytime" type="date" value-format="yyyy-MM-dd" placeholder="送货日期"></el-date-picker> -->
          <el-date-picker v-model="formInline.ddeliverytime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="物料名称">
          <el-input v-model="formInline.cinvname" placeholder="物料名称"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.csapcode" placeholder="物料名称"></el-input>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GitPurchaseorderList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border style="width: 100%" max-height="560" highlight-current-row :row-class-name="tableRowClassName" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="curgent" label="订单状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.curgent">
              <el-tag type="primary" size="small" v-if="scope.row.curgent=='已确认'">{{scope.row.curgent}}</el-tag>
              <el-tag type="danger" size="small" v-if="scope.row.curgent=='未确认'" effect="dark">{{scope.row.curgent}}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="cpastureinfo" label="公司信息" min-width="120"></el-table-column>
        <el-table-column prop="cinvname" label="物料信息" min-width="150"></el-table-column>
        <el-table-column prop="cjfmoney" label="奖罚金额" width="100"></el-table-column>
        <el-table-column prop="cxyjg" label="检验结果" width="100"></el-table-column>
        <el-table-column prop="csapcode" label="订单号" width="120"></el-table-column>
        <el-table-column prop="ccarcode" label="车牌号" width="100"></el-table-column>
        <!-- <el-table-column prop="dgbdate" label="过磅日期" width="100"></el-table-column> -->
        <!-- <el-table-column prop="dchecktime" label="检验日期" width="100"></el-table-column> -->
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看</el-button>
          </template>

        </el-table-column>
      </el-table>
      <div class="pull-right" style="padding:20px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        csapcode: "",
        ddeliverytime: [],
        ccorpcode: "",
        cinvname: "",

      },
      selectlist: {},
      options: [
        {
          value: "未确认",
          label: "未确认",
        },
        {
          value: "已确认",
          label: "已确认",
        },
      ],
      // 分页
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    // 公司
    if (this.$route.query.informdata) {
      if (this.$route.query.informdata.ccorpname != undefined) {
        this.formInline = {};
        this.formInline = this.$route.query.informdata;
      }
    }
    this.GetAccountInfo();
    this.GitPurchaseorderList();
  },

  methods: {
    // 判断高亮显示
    tableRowClassName({ row, rowIndex }) {
      if (row.dvencheckend != "") {
        const end = new Date(row.dvencheckend); // 定义开始时间且延长1小时
        const now = Date.parse(new Date()); // 获取本地时间
        const msec = end - now;
        if (msec < 0 && row.cvencheck == "未确认") {
          return "warning-row";
        } else {
          return "";
        }
      }
    },
    // 获取公司信息
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 获取信息
    GitPurchaseorderList() {
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      this.informdatanew = JSON.parse(JSON.stringify(this.formInline));
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetSupplierQueryListZJ",
        data: {
          dstart: starttime,
          dend: endtime,
          cinvname: this.formInline.cinvname,
          // endtime: endtime,
          ccorpcode: this.formInline.ccorpcode,
          csapcode: this.formInline.csapcode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res, "获取信息结果");
        if (res.data.Success) {
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GitPurchaseorderList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GitPurchaseorderList();
    },
    // 确认
    supedit(row) {
      this.$router.push({
        name: "QualityTestingZJ",
        params: { rows: row, informdata: this.informdatanew },
      });
    },
  },
};
</script>
<style scoped>
.inputwidth {
  width: 30%;
}
.inputwidth .el-input__inner {
  border: 0;
}
.el-table >>> .warning-row {
  background: oldlace;
}

/* .el-table >>> .success-row {
  background: #f0f9eb;
} */
</style>
